import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { GenericHelp } from '/components/common'
import Recaptcha from 'react-google-invisible-recaptcha'
import { GOOGLE_CAPTCHA_KEY } from '../../../config.js'
import api from 'services/api'
import './index.less'
import { Typography, Button, Row, Col, Form, Icon, notification } from 'antd'
const { Title } = Typography

export const Captcha = ({ captchaCallback, pin, deliveryBundleStatus }) => {
  const [isSubmitting, setSubmitting] = useState(false)
  const recaptcha = useRef(null)

  const onResolved = async () => {
    try {
      const { data } = await api.post(
        `/delivery-bundle/${pin}/validate-customer`,
        {
          data: recaptcha.current.getResponse(),
          type: 'captcha',
          browserIdentifier: localStorage.getItem('cid'),
        },
      )

      if (data.code === 'InvalidCaptcha') {
        notification.open({
          message: 'Ocorreu um erro ao tentar validar o Captcha.',
          icon: <Icon type='frown' style={{ color: '#ff0000' }} />,
        })
      } else if (data.code === 'InvalidCode') {
        notification.open({
          message:
            'Ocorreu um erro interno. Por favor, tente novamente em alguns minutos',
          icon: <Icon type='frown' style={{ color: '#ff0000' }} />,
        })
      } else if (data.code === 'NotAcceptable') {
        notification.open({
          message:
            'Ocorreu um erro. Por favor, entre em contato com o suporte.',
          icon: <Icon type='frown' style={{ color: '#ff0000' }} />,
        })
      } else {
        captchaCallback({
          verified: true,
          fetchedProducts: data.products,
          accessToken: data.accessToken,
        })
      }
    } catch (error) {
      notification.open({
        message:
          'Ocorreu um erro interno. Por favor, tente novamente em alguns minutos',
        icon: <Icon type='frown' style={{ color: '#ff0000' }} />,
      })
    }

    setSubmitting(false)
  }

  const onSubmit = e => {
    e.preventDefault()
    if (deliveryBundleStatus === 'DeliveryBundleNotFound') {
      captchaCallback({ verified: false })
    } else {
      setSubmitting(true)
      recaptcha.current.execute()
    }
  }

  return (
    <Row style={{ height: '100%' }}>
      <Col
        xs={{ span: 20, offset: 2 }}
        lg={{ span: 13, offset: 7 }}
        xl={{ offset: 7 }}
        xxl={{ offset: 6 }}
        id='captcha-form'
      >
        <Title level={4}>Clique em resgatar para ver seu código</Title>

        <Form onSubmit={onSubmit}>
          <Recaptcha
            ref={recaptcha}
            sitekey={GOOGLE_CAPTCHA_KEY}
            onResolved={onResolved}
          />

          <Button
            type='primary'
            htmlType='submit'
            id='submit'
            className='btn'
            block
            loading={isSubmitting}
          >
            Resgatar
          </Button>
        </Form>

        <GenericHelp />
      </Col>
    </Row>
  )
}

Captcha.propTypes = {
  /** Callback to be executed once the user is verified */
  captchaCallback: PropTypes.func.isRequired,

  /** Delivery bundle pin */
  pin: PropTypes.string,

  /** Delivery bundle status (if the pin code was not found) */
  deliveryBundleStatus: PropTypes.string,
}
